import { atom } from 'jotai'

export enum ChatHeaderState {
  None = 0,
  StartNewChat = 1,
  StartNewBoardChat = 2,
  StartNewInterestsChat = 5,
  FindArchivedChatsResident = 3,
  FindArchivedChats = 4,
}

export const chatHeaderStateAtom = atom(ChatHeaderState.None)

export enum ChatErrorState {
  None = 0,
  PendingRequest = 1,
  NoSociety = 2,
  ChatDisabled = 3,
  EmptyChat = 4,
  EmptyBoardChat = 5,
  EmptyGroupChat = 6,
  NoChatSelected = 7,
}

export const chatErrorStateAtom = atom(ChatErrorState.None)
